<div class="jumbotron polygons">
        <div class="container-xl container-fluid">
        <div class="row header-row align-items-start">
            <div class="header-wrapper">
                <div class="header-left pt-3">
                
                    <app-svg-sprite hash="{{'#icon-port' + equity + post}}" [width]=35 [height]=35 style="position:relative;margin-top:5px"></app-svg-sprite>
                        <h1 class="portfolioHeadingAndName">
                            <span class="ps-2" [innerHTML]="investment.displayName|safe:'html'"></span>                      
                        </h1>

                        <!-- <code>
                            <pre>
    {{investment|json}}                            
                            </pre>
                        </code> -->
                    
                   
                   
                            
                
                </div>
             
                <div class="header-right mt-4 pt-2 pe-0 portfolioNavigation"> 

                    <!-- <app-portfolio-balls-navigation [pre]="preRoute" [post]="preRoute" [prefix]="'icon-port'" [suffix]="post" (change)="portBallNavChange($event)"></app-portfolio-balls-navigation> -->
                     <!-- <app-portfolio-balls-navigation [post]="''" [pre]="`../s${s}-b${b}-`" [prefix]="'icon-port'" [suffix]="post" (change)="portBallNavChange($event)"></app-portfolio-balls-navigation> -->
                      <app-portfolio-balls-navigation [post]="''" [pre]="`/portfolios/s${s}-b${b}-`" [prefix]="'icon-port'" [suffix]="post" (change)="portBallNavChange($event)"></app-portfolio-balls-navigation>
                </div>
            </div>
    
            <div class="col-lg-12 justify-content-center p-3">
            <p [innerHtml]="(investment.description?investment.description:''|safe:'html')"></p>
            <!-- <p>S18B8 refers to various IFA Index allocations of stock and bond indexes. Please contact an IFA Wealth Advisor for more details on index <a routerLink="/fund-options" class="text-light">fund options</a>.</p> -->
            <p>The <span (click)="pballClick2()">data</span> provided in <span (click)="pballClick()">charts</span> referring to IFC Index Portfolios is hypothetical back-tested performance and is
                not actual client performance. Performance data for the IFC Index Portfolios is shown net of IFC's highest
                advisory fee and the underlying mutual fund expenses. IFC Indexes when shown individually do not reflect a
                deduction of advisory fees. None of the data reflects trading costs or taxes, which would have lowered
                performance by these costs. <a routerLink="/disclosures">See more important disclosures.</a>.</p>
            </div>
        </div>
        </div>
    </div>